import { DATE_RANGES, AGGREGATION_TYPE } from '@/constants/analytics';

/**
 *
 * @param {DATE_RANGES} range
 */
function getAggregationByRange(range) {
  let aggregationType;

  switch (range) {
    case DATE_RANGES.ALL_TIME:
      aggregationType = AGGREGATION_TYPE.YEAR;
      break;
    case DATE_RANGES.REALTIME:
      aggregationType = AGGREGATION_TYPE.HOUR;
      break;
    case DATE_RANGES.THIS_MONTH:
    case DATE_RANGES.LAST_MONTH:
      aggregationType = AGGREGATION_TYPE.DAY;
      break;
    case DATE_RANGES.THIS_YEAR:
      aggregationType = AGGREGATION_TYPE.MONTH;
      break;
    default:
      throw new Error('Not correct range is provided');
  }

  return aggregationType;
}

export default getAggregationByRange;
